import { rem } from '../../../utils/rem';
export var MuiToolbar = {
    styleOverrides: {
        regular: {
            minHeight: rem(56),
            '@media (min-width: 600px)': {
                minHeight: rem(56),
            },
        },
    },
};
